// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1u1PP","title":"AfterBackImages_title__2fUME","images":"AfterBackImages_images__3Jv55"};